import NoficationOpen from './notification/NoficationOpen';

export const SystemError = (error, setError, notificationDispatch) => {
    const _renderError = () => {
        if (typeof error === 'string') {
            return NoficationOpen({ role: 'danger', title: 'Error', message: error, notificationDispatch });
        } else if (typeof error === 'object') {
            error?.forEach((err) => {
                // To show input validation dynamically
                return setError(Object.keys(err)[0], { type: 'manual', message: Object.values(err)[0] });
            });
        }
    };
    return _renderError();
};
